// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import Router from 'vue-router'
import router from './router'
import Element from './element';
import 'element-ui/lib/theme-chalk/index.css';
import './permission';
import store from '@/store';
import Katex from '@/utils/directives';
// import 'katex/dist/katex.min.css';
import ECharts from 'vue-echarts/components/ECharts.vue';
// import { ubbToHtml } from '@/utils/directive';
import { getUserLocalData } from "@/utils/auth";
// import Mock from '@/mock';

import Message from '@/components/Message'
Vue.prototype.$ly_message = Message.install;

import SoftSwitch from '@/components/SoftSwitch'
Vue.prototype.$soft_switch = SoftSwitch.install;

import Notify from '@/components/Notification';
Vue.prototype.$sl_notify = Notify.install;

const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(Katex);
// Vue.use(ubbToHtml);
Vue.use(Element);
Vue.use(router);
Vue.config.productionTip = false;


import VConsole from 'vconsole'
new VConsole()

// if (process.env.NODE_ENV === 'production') {
//   new VConsole()
// }
// register component to use
Vue.component('v-chart', ECharts);
/* eslint-disable no-new */
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js